/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum GradeLevelEnum {
    grade_level_1_2 = 1,
    grade_level_3_4 = 2,
    grade_level_lower = 3,
    grade_level_middle = 4,
    grade_level_high = 5,
}
